import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { useOpenUnsavedChangesModal } from 'seagull';
const compareLocation = (locationA, locationB)=>{
    return locationA.pathname === locationB.pathname && locationA.search === locationB.search && locationA.hash === locationB.hash;
};
export function NavigationGuardModal(param) {
    let { when, primaryButtonTestId, secondaryButtonTestId } = param;
    const openUnsavedChangesModal = useOpenUnsavedChangesModal();
    const history = useHistory();
    const [lastNavigation, setLastNaviation] = useState(null);
    useEffect(()=>{
        if (lastNavigation) history.push(lastNavigation);
    }, [
        lastNavigation
    ]);
    return /*#__PURE__*/ _jsx(Prompt, {
        when: when,
        message: (nextLocation)=>{
            if (lastNavigation && compareLocation(lastNavigation, nextLocation)) {
                return true;
            } else {
                openUnsavedChangesModal({
                    primaryButtonTestId,
                    secondaryButtonTestId
                }).then((confirmedNavigation)=>{
                    if (confirmedNavigation) {
                        setLastNaviation(nextLocation);
                    }
                });
                return false;
            }
        }
    });
}
